var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6809 4.90828C14.3468 4.90726 15.9592 5.49592 17.2325 6.56998L20.7991 3.1735C19.43 1.91105 17.7854 0.985087 15.996 0.469106C14.2066 -0.0468738 12.3215 -0.138671 10.4904 0.200999C8.65927 0.540669 6.93253 1.30246 5.44721 2.42591C3.96188 3.54936 2.75885 5.00354 1.93359 6.67305L5.95451 9.77232C6.42344 8.35825 7.3254 7.12757 8.53263 6.2546C9.73986 5.38162 11.1911 4.91061 12.6809 4.90828Z",
    fill: "#D94F3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59168 11.9967C5.59268 11.2402 5.71532 10.4887 5.95489 9.77114L1.93397 6.67188C1.11149 8.32643 0.683472 10.149 0.683472 11.9967C0.683472 13.8444 1.11149 15.667 1.93397 17.3216L5.95489 14.2223C5.71532 13.5047 5.59268 12.7533 5.59168 11.9967Z",
    fill: "#F2C042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1882 9.81641H12.7357V14.7246H19.2255C18.8394 16.1124 17.9549 17.309 16.7414 18.0851L20.7312 21.1609C23.2807 18.8726 24.7788 15.1516 24.1882 9.81641Z",
    fill: "#5085ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7395 18.0843C15.5065 18.7901 14.1008 19.1372 12.6809 19.0867C11.1911 19.0844 9.73986 18.6133 8.53263 17.7404C7.3254 16.8674 6.42344 15.6367 5.95451 14.2227L1.93359 17.3219C2.92677 19.324 4.45884 21.0092 6.3575 22.1881C8.25615 23.367 10.4461 23.9927 12.6809 23.9949C15.6217 24.0748 18.4882 23.0648 20.7293 21.159L16.7395 18.0843Z",
    fill: "#57A75C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.375beb2415aacf5edc76edc97ec8587c.svg";
export { ForwardRef as ReactComponent };